/**
 * @file Route: categorysingletwo
 *
 * This file is compiled as a standalone entrypoint and it is included by
 * default in its blade template.
 * This is a "standard" route, it does not have a structure to follow, you are
 * sure the DOM is always ready and the JS will only be executed in this route.
 */

import "./index.scss";
import "layouts/main";

import noUiSlider from "nouislider";
import Choices from "Choices.js";
import List from "list.js";

//import 'simplebar'; // or "import SimpleBar from 'simplebar';" if you want to use it manually.
// import 'simplebar/dist/simplebar.css';

// You will need a ResizeObserver polyfill for browsers that don't support it! (iOS Safari, Edge, ...)
import ResizeObserver from 'resize-observer-polyfill';
// window.ResizeObserver = ResizeObserver;

import { Filters } from "components/Filters"
import { Pagination } from "components/Category/Pagination"
import { CategoryProduct } from "components/Category/Product"
import { initWishlist, wishlistOn } from "@olmokit/core/wishlist"
import { ProductCard } from "components/Product/Card"

console.log("Route macrocategory/index.js mounted.");

initWishlist();

Filters();
Pagination();
CategoryProduct();
ProductCard();

/**
 * Range slider
 * @requires https://refreshless.com/nouislider/
 */
  
(() => {
    const rangeSliderWidgets = document.querySelectorAll('[data-range-slider]');
    if (rangeSliderWidgets.length === 0) return;

    // Check the dir attribute on html tag and set the default to "ltr" if it's not set or invalid
    const htmlElement = document.documentElement;
    const direction = htmlElement.getAttribute('dir') === 'ltr' || htmlElement.getAttribute('dir') === 'rtl' ? htmlElement.getAttribute('dir') : 'ltr';
    rangeSliderWidgets.forEach(rangeSliderWidget => {
      const rangeSlider = rangeSliderWidget.querySelector('.range-slider-ui');
      const valueMinInput = rangeSliderWidget.querySelector('[data-range-slider-min]');
      const valueMaxInput = rangeSliderWidget.querySelector('[data-range-slider-max]');
      let dataOptions;
      if (rangeSliderWidget.dataset.rangeSlider !== undefined) dataOptions = JSON.parse(rangeSliderWidget.dataset.rangeSlider);
      const options = {
        startMin: parseInt(dataOptions.startMin, 10),
        startMax: parseInt(dataOptions.startMax, 10),
        min: parseInt(dataOptions.min, 10),
        max: parseInt(dataOptions.max, 10),
        step: parseInt(dataOptions.step, 10),
        pips: dataOptions.pips,
        tooltipPrefix: dataOptions.tooltipPrefix || '',
        tooltipSuffix: dataOptions.tooltipSuffix || ''
      };
      const start = options.startMax ? [options.startMin, options.startMax] : [options.startMin];
      const connect = options.startMax ? true : 'lower';

      /* eslint-disable no-undef */
      noUiSlider.create(rangeSlider, {
        direction: direction,
        start: start,
        connect: connect,
        step: options.step,
        pips: options.pips ? {
          mode: 'count',
          values: 5
        } : false,
        tooltips: true,
        range: {
          min: options.min,
          max: options.max
        },
        format: {
          to: function (value) {
            return options.tooltipPrefix + parseInt(value, 10) + options.tooltipSuffix;
          },
          from: function (value) {
            return Number(value);
          }
        }
      });
      rangeSlider.noUiSlider.on('update', (values, handle) => {
        let value = values[handle];
        value = value.replace(/\D/g, '');
        if (handle) {
          if (valueMaxInput) {
            valueMaxInput.value = Math.round(value);
          }
        } else {
          if (valueMinInput) {
            valueMinInput.value = Math.round(value);
          }
        }
      });
      if (valueMinInput) {
        valueMinInput.addEventListener('change', function () {
          rangeSlider.noUiSlider.set([this.value, null]);
        });
      }
      if (valueMaxInput) {
        valueMaxInput.addEventListener('change', function () {
          rangeSlider.noUiSlider.set([null, this.value]);
        });
      }
    });
    /* eslint-enable no-undef */
  })();


    /**
     * Search, sort and filter lists and tables
     * @requires https://listjs.com/
     */
  
    (() => {
        const filterListContainers = document.querySelectorAll('[data-filter-list]');
        if (filterListContainers.length === 0) return;
    
        // Clear button functions
        const createClearButton = (container, searchField) => {
          const clearButton = document.createElement('button');
          clearButton.className = 'btn btn-sm btn-outline-secondary w-auto border-0 p-1 position-absolute top-50 end-0 translate-middle-y me-2 opacity-0';
          clearButton.innerHTML = `
          <svg class="opacity-75" width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
            <path d="M18.619 5.381a.875.875 0 0 1 0 1.238l-12 12A.875.875 0 0 1 5.38 17.38l12-12a.875.875 0 0 1 1.238 0Z"/><path d="M5.381 5.381a.875.875 0 0 1 1.238 0l12 12a.875.875 0 1 1-1.238 1.238l-12-12a.875.875 0 0 1 0-1.238Z"/>
          </svg>
        `;
          container.appendChild(clearButton);
          updateClearButtonVisibility(searchField, clearButton);
          return clearButton;
        };
        const updateClearButtonVisibility = (searchField, clearButton) => {
          clearButton.classList.toggle('opacity-0', searchField.value === '');
        };
        const clearSearchField = (searchField, clearButton) => {
          searchField.value = '';
          updateClearButtonVisibility(searchField, clearButton);
        };
    
        // Init list filtering
        /* eslint-disable no-unused-vars, no-undef */
        [...filterListContainers].map(filterListsEl => {
          const options = JSON.parse(filterListsEl.dataset.filterList);
          const searchFields = filterListsEl.querySelectorAll('.' + options.searchClass);
          if (searchFields.length) {
            const clearButton = createClearButton(searchFields[0].parentNode, searchFields[0]);
            searchFields.forEach(searchField => {
              searchField.addEventListener('input', () => {
                updateClearButtonVisibility(searchField, clearButton);
              });
            });
            clearButton.addEventListener('click', () => {
              searchFields.forEach(searchField => {
                clearSearchField(searchField, clearButton);
              });
              filterList.search();
            });
          }
          const filterList = new List(filterListsEl, options);
          return filterList;
        });
        /* eslint-enable no-unused-vars, no-undef */
      })();